module.exports = __webpack_public_path__ + "static/media/map.e8a317c8.png";